import HttpRequest from "../../utilities/httpRequest";
import { showSnackbar } from "../../utilities/UtilitiesActions";

/**
 * Doctor <-> Google Calendar connection.
 *
 * Online consultations need a Google Meet link, and Google only lets the account
 * that created a meeting host it. So each doctor connects their own Google
 * account once; the backend then creates every future meeting as them.
 *
 * No loader is shown for the status check — it runs on dashboard mount and must
 * not block the page.
 */
export const getGoogleCalendarStatusRequest = () => {
  return (dispatch) => {
    return new HttpRequest(dispatch, "google/calendar/status", "get")
      .send()
      .then(
        (res) => Promise.resolve(res.data.data),
        // A failure here only means we cannot tell — never surface it to the doctor.
        () => Promise.resolve(null)
      );
  };
};

/**
 * Ask the backend for the Google consent URL. It must be fetched (not linked to
 * directly) because the endpoint needs the Authorization header.
 */
export const getGoogleConsentUrlRequest = () => {
  return (dispatch) => {
    return new HttpRequest(dispatch, "google/calendar/connect", "get")
      .send()
      .then(
        (res) => Promise.resolve(res.data.data.url),
        (error) => {
          dispatch(
            showSnackbar(
              error?.response?.data?.error ||
                "Could not start Google sign-in. Please try again.",
              "error"
            )
          );
          return Promise.reject(error);
        }
      );
  };
};

export const disconnectGoogleCalendarRequest = () => {
  return (dispatch) => {
    return new HttpRequest(dispatch, "google/calendar", "delete")
      .send()
      .then(
        (res) => {
          dispatch(showSnackbar("Google Calendar disconnected", "success"));
          return Promise.resolve(res.data.data);
        },
        (error) => {
          dispatch(
            showSnackbar(
              error?.response?.data?.error || "Could not disconnect",
              "error"
            )
          );
          return Promise.reject(error);
        }
      );
  };
};
